import React, { memo } from "react";

import { PopoverText } from '../../common/parts/PopoverText';
import { CourceRadio } from "../parts/CourceRadio";

export const FormCource = memo((props) => {
  const { cources } = props;

  return (
    <>
      <p className="h3">コースの選択 
        <PopoverText textTitle="まずコースを選択してください" textBody="コースはご年齢やその他の条件によって選択できるコースを表示しています。表示さていないコースは選択できません。" />
      </p>
      <div className="list-group mb-4">
        {cources.map(item => 
          <CourceRadio key={item.id} item={item} />
        )}
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});